<mat-card-content class="mve-detail-popup-container" *ngIf="currentDevice">
  <mat-card-header>
    <mat-toolbar color="accent" fxLayoutAlign="space-between center">
      <h2 fxFlex fxLayout="row" fxLayoutAlign="start center">
        {{ currentDevice.name }}
        <div *ngIf="sendingStatusColor" class="dot" [style.background-color]="sendingStatusColor"></div>
        <mat-progress-spinner *ngIf="updating || loading" style="margin-left: 20px" mode="indeterminate" [diameter]="20"
          color="white"></mat-progress-spinner>
      </h2>
    </mat-toolbar>
  </mat-card-header>
  <mat-tab-group *ngIf="currentDeviceConfiguration" [(selectedIndex)]="selectedTabIndex"
    (selectedTabChange)="onTabChange($event)" mat-align-tabs="start" color="accent">

    <!-- Storage configuration -->
    <mat-tab label="{{ 'DEVICE_DETAIL.TAB_STORAGE.TITLE' | translate }}">
      <div fxLayout="row" fxFlex>
        <div [fxLayoutAlign]="'center center'" [fxFlex]="'30%'">
          <div fxLayout="column" [fxLayoutAlign]="'center center'" fxFlex style="border-right: 1px solid darkgray;">
            <div style="text-align: center;">
              <img style="width: 90%; padding-top: 10px;" src="../../../assets/img/project/fewis_device.png" />
            </div>
            <div>
              <p>{{ 'DEVICE_DETAIL.TAB_STORAGE.INPUT_SELECTION' | translate }}</p>
              <mat-button-toggle-group [(value)]="selectedDeviceInput" (change)="onChangeDeviceInput($event.value)"
                #deviceInputSelection="matButtonToggleGroup">
                <mat-button-toggle value="E1">E1</mat-button-toggle>
                <mat-button-toggle value="E2">E2</mat-button-toggle>
                <mat-button-toggle value="E3">E3</mat-button-toggle>
                <mat-button-toggle value="E4">E4</mat-button-toggle>
              </mat-button-toggle-group>
            </div>
          </div>
        </div>
        <div [fxLayoutAlign]="'start center'" [fxFlex]="'70%'" style="padding-left: 5px;">
          <div fxLayout="column" fxFlex>
            <div [fxLayoutAlign]="'center center'"
              *ngIf="selectedStorageConfiguration !== null && !selectedStorageConfiguration.active">
              <div fxLayout="column" [fxLayoutAlign]="'center center'" fxFlex>
                <div><span class="material-icons" style="font-size: 90pt;">sensors_off</span></div>
                <div>
                  {{ 'DEVICE_DETAIL.TAB_STORAGE.INPUT_NOT_CONFIGURED' | translate }}
                </div>
                <div style="padding-top: 10px">
                  <button mat-raised-button (click)="selectedStorageConfiguration.active = true" [disabled]="!authService.isAdminUser && !authService.isSuperAdminUser"
                    (change)="storageForm.markAsDirty()" translate>CONFIGURE</button>
                </div>
              </div>
            </div>
            <div [fxLayoutAlign]="'start center'"
              *ngIf="selectedStorageConfiguration !== null && selectedStorageConfiguration.active"
              style="padding-left: 5px;">
              <mat-checkbox [(ngModel)]="selectedStorageConfiguration.active" (change)="storageForm.markAsDirty()" [disabled]="!authService.isAdminUser && !authService.isSuperAdminUser">
                {{ 'DEVICE_DETAIL.TAB_STORAGE.STORAGE.INPUT_ACTIVE' | translate:{ inputName: selectedDeviceInput} }}
              </mat-checkbox>
            </div>
            <div style="padding-bottom: 5px;">
              <form [formGroup]="storageForm" autocomplete="off" style="width: 100%">
                <div fxLayout="row" fxLayoutAlign="space-around start" fxFlex
                  *ngIf="selectedStorageConfiguration !== null && selectedStorageConfiguration.active">
                  <div>
                    <div fxLayout="column" fxFlex style="padding: 10px 10px 0 0;">
                      <div fxLayout="column" fxFlex>
                        <fieldset class="storage-panel">
                          <legend>{{ 'DEVICE_DETAIL.TAB_STORAGE.STORAGE.TITLE' | translate }}</legend>
                          <div fxLayout="column" fxFlex>
                            <div>
                              <mat-form-field>
                                <mat-label>{{ 'DEVICE_DETAIL.TAB_STORAGE.STORAGE.PRODUCT' | translate }}</mat-label>
                                <mat-select formControlName="product" (selectionChange)="onChangeProduct($event)">
                                  <mat-option *ngFor="let item of allProducts" [value]="item.id">{{item.name}}</mat-option>
                                </mat-select>
                              </mat-form-field>
                            </div>
                            <div>
                              <mat-form-field>
                                <mat-label>{{ 'DEVICE_DETAIL.TAB_STORAGE.STORAGE.CAPACITY' | translate }}</mat-label>
                                <input formControlName="capacity" matInput type="number" min="0"
                                  (change)="onCapacityChange($event); currentDeviceConfigurationedited = true" />
                                <mat-error *ngIf="storageForm.controls.capacity.hasError('min')">{{
                                  'INVALID_VALUE' | translate }}</mat-error>
                              </mat-form-field>
                            </div>
                            <div>
                              <mat-form-field>
                                <mat-label>{{ 'DEVICE_DETAIL.TAB_STORAGE.STORAGE.GEOMETRICAL_CAPACITY' | translate }}
                                  ({{selectedStorageConfiguration.unit}})</mat-label>
                                <input formControlName="geometricalCapacity" matInput type="number" required min="0"
                                  (change)="onGeometricalCapacityChange($event); currentDeviceConfigurationedited = true" />
                                <mat-error *ngIf="storageForm.controls.geometricalCapacity.hasError('required')">{{
                                  'MANDATORY' | translate }}</mat-error>
                                <mat-error *ngIf="storageForm.controls.geometricalCapacity.hasError('min')">{{
                                  'INVALID_VALUE' | translate }}</mat-error>
                              </mat-form-field>
                            </div>
                            <div>
                              <mat-form-field>
                                <mat-label>{{ 'DEVICE_DETAIL.TAB_STORAGE.STORAGE.TECHNICAL_CAPACITY' | translate }}
                                  ({{selectedStorageConfiguration.unit}})</mat-label>
                                <input formControlName="technicalCapacity" matInput type="number" min="0" required />
                                <mat-error *ngIf="storageForm.controls.technicalCapacity.hasError('required')">{{
                                  'MANDATORY' | translate }}</mat-error>
                                <mat-error *ngIf="storageForm.controls.technicalCapacity.hasError('min')">{{
                                  'INVALID_VALUE' | translate }}</mat-error>
                              </mat-form-field>
                            </div>
                            <div>
                              <mat-form-field>
                                <mat-label>{{ 'DEVICE_DETAIL.TAB_STORAGE.STORAGE.MIN_TECHNICAL_CAPACITY' | translate }}
                                  ({{selectedStorageConfiguration.unit}})</mat-label>
                                <input formControlName="minTechnicalCapacity" matInput type="number" min="0" />
                                <mat-error *ngIf="storageForm.controls.minTechnicalCapacity.hasError('min')">{{
                                  'INVALID_VALUE' | translate }}</mat-error>
                              </mat-form-field>
                            </div>
                          </div>
                        </fieldset>
                      </div>
                    </div>
                  </div>
                  <div fxLayout="column" fxFlex style="padding-top: 10px;">
                    <div fxLayout="row" fxFlex>
                      <div>
                        <div fxLayout="column" fxFlex>
                          <div>
                            <fieldset class="storage-panel">
                              <legend>{{ 'DEVICE_DETAIL.TAB_STORAGE.STORAGE.ALARM_THRESHOLDS.TITLE' | translate }}</legend>
                              <div fxLayout="column" fxFlex>
                                <div fxLayout="row" fxFlex>
                                  <div>
                                    <span class="material-icons">
                                      looks_one
                                    </span>
                                  </div>
                                  <div>
                                    <mat-form-field>
                                      <mat-label>{{ 'DEVICE_DETAIL.TAB_STORAGE.STORAGE.ALARM_THRESHOLDS.LOW_THRESHOLD' |
                                        translate
                                        }}
                                        ({{selectedStorageConfiguration.unit}})</mat-label>
                                      <input formControlName="lowThreshold" matInput type="number" min="0" required />
                                      <mat-error *ngIf="storageForm.controls.lowThreshold.hasError('required')">{{
                                        'MANDATORY' | translate }}</mat-error>
                                      <mat-error *ngIf="storageForm.controls.lowThreshold.hasError('required')">{{
                                        'INVALID_VALUE' | translate }}</mat-error>
                                    </mat-form-field>
                                  </div>
                                </div>
                                <div fxLayout="row" fxFlex>
                                  <div>
                                    <span class="material-icons">
                                      looks_two
                                    </span>
                                  </div>
                                  <div>
                                    <mat-form-field>
                                      <mat-label>{{ 'DEVICE_DETAIL.TAB_STORAGE.STORAGE.ALARM_THRESHOLDS.LOWLOW_THRESHOLD' |
                                        translate }}
                                        ({{selectedStorageConfiguration.unit}})</mat-label>
                                      <input formControlName="lowLowThreshold" matInput type="number" min="0" required />
                                      <mat-error *ngIf="storageForm.controls.lowLowThreshold.hasError('required')">{{
                                        'MANDATORY' | translate }}</mat-error>
                                      <mat-error *ngIf="storageForm.controls.lowLowThreshold.hasError('required')">{{
                                        'INVALID_VALUE' | translate }}</mat-error>
                                    </mat-form-field>
                                  </div>
                                </div>
                                <div fxLayout="row" fxFlex>
                                  <mat-checkbox formControlName="createAlarmOnEiu">
                                    {{ 'DEVICE_DETAIL.TAB_STORAGE.STORAGE.ALARM_THRESHOLDS.CREATE_ALARM_ON_EIU' | translate: { inputName: selectedDeviceInput } }}
                                  </mat-checkbox>
                                </div>
                              </div>
                            </fieldset>
                          </div>
                          <div style="margin-top: 40px;">
                            <fieldset class="storage-panel">
                              <legend>{{ 'DEVICE_DETAIL.TAB_STORAGE.STORAGE.SENSOR.TITLE' | translate }}</legend>
                              <div fxLayout="column" fxFlex>
                                <div>
                                  <mat-form-field>
                                    <mat-label>{{ 'DEVICE_DETAIL.TAB_STORAGE.STORAGE.SENSOR.TRANSMITTER_TYPE' | translate }}
                                    </mat-label>
                                    <input formControlName="transmitterType" matInput type="text" />
                                  </mat-form-field>
                                </div>
                                <div>
                                  <mat-checkbox formControlName="disableConvert4_20">
                                    {{ 'DEVICE_DETAIL.TAB_STORAGE.STORAGE.SENSOR.DISABLE_4_20_CONVERSION' | translate }}
                                  </mat-checkbox>
                                </div>
                              </div>
                            </fieldset>
                          </div>
                        </div>
                      </div>
                      <div style="text-align: center;">
                        <img style="width: 50%" src="./assets/img/project/storage.png" />
                      </div>
                    </div>
                    <div *ngIf="storageForm.errors?.thresholdsConsistency" style="text-align: center; padding-top: 10px">
                      <mat-error>{{
                        'DEVICE_DETAIL.TAB_STORAGE.STORAGE.ALARM_THRESHOLDS.INCONSISTENT_THRESHOLD_VALUE' | translate }}
                      </mat-error>
                    </div>
                    <div *ngIf="selectedStorageConfiguration.thresholdsEdited" style="display: flex;">
                      <span class="material-icons" style="color: orange">warning</span>
                      <span translate>DEVICE_DETAIL.TAB_STORAGE.STORAGE.CONFIGURATION_UPDATE_PENDING</span>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </mat-tab>


    <!-- Cyclical call configuration -->
    <mat-tab label="{{ 'DEVICE_DETAIL.TAB_CYCLICAL_CALL.TITLE' | translate }}">
      <div fxLayout="row" fxFlex class="master-view-engine-container">
        <div style="padding: 15px; width: 100%; min-height: 300px;">
          <div fxLayout="row" fxFlex>
            <div [fxLayoutAlign]="'center center'" [fxFlex]="'40%'">
              <span class="material-icons" style="font-size: 90pt;">schedule</span>
            </div>
            <div [fxLayoutAlign]="'start center'" [fxFlex]="'60%'">
              <form [formGroup]="cyclicalCallForm" autocomplete="off" style="width: 100%">
                <div fxLayout="column" fxFlex>
                  <div style="padding-bottom: 20px;">
                    <span class="label">{{ 'DEVICE_DETAIL.TAB_CYCLICAL_CALL.CONFIGURE_SCHEDULE' | translate }}</span>
                  </div>
                  <div>
                    <mat-form-field style="width: 100%;">
                      <mat-label>{{ 'DEVICE_DETAIL.TAB_CYCLICAL_CALL.PERIOD_TYPE.LABEL' | translate }}</mat-label>
                      <mat-select formControlName="callPeriodType">
                        <mat-option [value]="'h'">{{ 'DEVICE_DETAIL.TAB_CYCLICAL_CALL.PERIOD_TYPE.HOURLY' | translate }}
                        </mat-option>
                        <mat-option [value]="'t'">{{ 'DEVICE_DETAIL.TAB_CYCLICAL_CALL.PERIOD_TYPE.DAILY' | translate }}
                        </mat-option>
                        <mat-option [value]="'w'">{{ 'DEVICE_DETAIL.TAB_CYCLICAL_CALL.PERIOD_TYPE.WEEKLY' | translate }}
                        </mat-option>
                        <mat-option [value]="'m'">{{ 'DEVICE_DETAIL.TAB_CYCLICAL_CALL.PERIOD_TYPE.MONTHLY' | translate
                          }}
                        </mat-option>
                      </mat-select>
                      <mat-error *ngIf="cyclicalCallForm.controls.callPeriodType.hasError('required')">{{ 'MANDATORY' |
                        translate }}</mat-error>
                    </mat-form-field>
                  </div>

                  <div [hidden]="cyclicalCallForm.controls.callPeriodType.value !== 'w'">
                    <mat-form-field style="width: 100%;">
                      <mat-label>{{ 'DEVICE_DETAIL.TAB_CYCLICAL_CALL.WEEK_DAYS.LABEL' | translate }}</mat-label>
                      <mat-select formControlName="callWeekDays" multiple>
                        <mat-option [value]="1">{{ 'DEVICE_DETAIL.TAB_CYCLICAL_CALL.WEEK_DAYS.MONDAY' | translate }}
                        </mat-option>
                        <mat-option [value]="2">{{ 'DEVICE_DETAIL.TAB_CYCLICAL_CALL.WEEK_DAYS.TUESDAY' | translate }}
                        </mat-option>
                        <mat-option [value]="3">{{ 'DEVICE_DETAIL.TAB_CYCLICAL_CALL.WEEK_DAYS.WEDNESDAY' | translate }}
                        </mat-option>
                        <mat-option [value]="4">{{ 'DEVICE_DETAIL.TAB_CYCLICAL_CALL.WEEK_DAYS.THURSDAY' | translate }}
                        </mat-option>
                        <mat-option [value]="5">{{ 'DEVICE_DETAIL.TAB_CYCLICAL_CALL.WEEK_DAYS.FRIDAY' | translate }}
                        </mat-option>
                        <mat-option [value]="6">{{ 'DEVICE_DETAIL.TAB_CYCLICAL_CALL.WEEK_DAYS.SATURDAY' | translate }}
                        </mat-option>
                        <mat-option [value]="7">{{ 'DEVICE_DETAIL.TAB_CYCLICAL_CALL.WEEK_DAYS.SUNDAY' | translate }}
                        </mat-option>
                      </mat-select>
                      <mat-error *ngIf="cyclicalCallForm.controls.callWeekDays.hasError('required')">{{ 'MANDATORY' |
                        translate }}</mat-error>
                    </mat-form-field>
                  </div>

                  <div [hidden]="cyclicalCallForm.controls.callPeriodType.value !== 'm'">
                    <mat-form-field style="width: 100%;">
                      <mat-label>{{ 'DEVICE_DETAIL.TAB_CYCLICAL_CALL.MONTH_DAY' | translate }}</mat-label>
                      <input matInput type="number" min="0" max="31" formControlName="callDay" />
                      <mat-error *ngIf="cyclicalCallForm.controls.callDay.hasError('required')">{{ 'MANDATORY' |
                        translate
                        }}</mat-error>
                      <mat-error
                        *ngIf="cyclicalCallForm.controls.callDay.hasError('min') || cyclicalCallForm.controls.callDay.hasError('max')">
                        {{ 'INVALID_VALUE' | translate }}</mat-error>
                    </mat-form-field>
                  </div>

                  <div>
                    <ngx-timepicker-field [format]="24" [buttonAlign]="'left'" formControlName="callTime"
                      [defaultTime]="'00:00'" [cancelBtnTmpl]="cancelBtn" [confirmBtnTmpl]="confirmBtn">
                      <ng-template #cancelBtn>
                        <button mat-button style="margin-right: 10px;">{{ "CANCEL" | translate }}</button>
                      </ng-template>
                      <ng-template #confirmBtn>
                        <button mat-button>{{ "CONFIRM" | translate }}</button>
                      </ng-template>
                      <mat-error *ngIf="cyclicalCallForm.controls.callTime.hasError('required')">{{ 'MANDATORY' |
                        translate }}</mat-error>
                    </ngx-timepicker-field>
                  </div>

                  <div *ngIf="currentDeviceConfiguration?.configuration?.callScheduleEdited"
                    style="padding-top: 10px; display: inline-flex; align-items: center;">
                    <div>
                      <span class="material-icons" style="color: orange">warning</span>
                    </div>
                    <div>
                      <span translate>DEVICE_DETAIL.TAB_CYCLICAL_CALL.CONFIGURATION_UPDATE_PENDING</span>
                    </div>
                  </div>

                </div>
              </form>
            </div>
          </div>

        </div>
      </div>
    </mat-tab>


    <!-- Manual SMS sending -->
    <mat-tab label="{{ 'DEVICE_DETAIL.TAB_MANUAL_SMS.TITLE' | translate }}">
      <div fxLayout="row" fxFlex class="master-view-engine-container">

        <div style="padding: 15px; width: 100%; min-height: 300px;">
          <div fxLayout="row" fxFlex>
            <div [fxLayoutAlign]="'center center'" [fxFlex]="'40%'">
              <span class="material-icons" style="font-size: 90pt;">send</span>
            </div>
            <div [fxLayoutAlign]="'start center'" [fxFlex]="'60%'">
              <form [formGroup]="manualCommandForm" autocomplete="off" style="width: 100%">
                <div fxLayout="column" fxFlex>
                  <div style="padding-bottom: 20px;">
                    <span class="label">{{ 'DEVICE_DETAIL.TAB_MANUAL_SMS.SELECT_COMMAND' | translate }}</span>
                  </div>
                  <div>
                    <mat-form-field style="width: 100%;">
                      <mat-label>{{ 'DEVICE_DETAIL.TAB_MANUAL_SMS.COMMAND' | translate }}</mat-label>
                      <mat-select formControlName="command">
                        <mat-option *ngFor="let operation of allOperations" [value]="operation">
                          {{ operation['label'] }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div
                    [hidden]="manualCommandForm.controls.command.value === null || !manualCommandForm.controls.command.value['allowsParameter']">
                    <mat-form-field style="width: 100%;">
                      <mat-label>{{ 'DEVICE_DETAIL.TAB_MANUAL_SMS.PARAMETER' | translate }}</mat-label>
                      <input matInput type="text" formControlName="commandParameter" />
                      <mat-error *ngIf="manualCommandForm.controls.commandParameter.hasError('required')">{{ 'MANDATORY'
                        |
                        translate }}</mat-error>
                    </mat-form-field>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>

      </div>
    </mat-tab>

    <!-- All settings -->
    <mat-tab label="{{ 'DEVICE_DETAIL.TAB_SETTINGS.TITLE' | translate }}">
      <div fxLayout="row" fxFlex class="master-view-engine-container">
        <div class="table-settings-container">
          <table class="mat-table">
            <thead>
              <tr class="table-row-header mat-header-row">
                <th class="mat-header-cell" [fxLayoutAlign]="'start center'" [fxFlex]="'35%'">
                  {{ 'DEVICE_DETAIL.TAB_SETTINGS.PARAMETER_NAME' | translate }}
                </th>
                <th class="mat-header-cell" [fxLayoutAlign]="'center center'" [fxFlex]="'65%'">
                  {{ 'DEVICE_DETAIL.TAB_SETTINGS.PARAMETER_VALUE' | translate }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr class="table-row-content" [hidden]="!currentDeviceConfiguration.softwareVersion">
                <td class="mat-cell" [fxLayoutAlign]="'start center'" [fxFlex]="'35%'">
                  {{ 'DEVICE_DETAIL.TAB_SETTINGS.FIRMWARE_VERSION' | translate }}
                </td>
                <td class="mat-cell" [fxLayoutAlign]="'center center'" [fxFlex]="'65%'">
                  {{ currentDeviceConfiguration.model }} {{ currentDeviceConfiguration.softwareVersion }}
                </td>
              </tr>
              <tr class="table-row-content" *ngIf="currentDeviceConfiguration?.lastValues && currentDeviceConfiguration?.lastValues['RL']">
                <td class="mat-cell" [fxLayoutAlign]="'start center'" [fxFlex]="'35%'">
                  {{ 'DEVICE_DETAIL.TAB_SETTINGS.LAST_RADIO_LEVEL' | translate }}
                </td>
                <td class="mat-cell" [fxLayoutAlign]="'center center'" [fxFlex]="'65%'">
                  {{ currentDeviceConfiguration?.lastValues['RL']['value'] }}%&nbsp;({{ currentDeviceConfiguration?.lastValues['RL']['timestamp'] | dateFormat }})
                </td>
              </tr>
              <tr class="table-row-content" *ngIf="currentDeviceConfiguration?.lastValues && currentDeviceConfiguration?.lastValues['TEMP']">
                <td class="mat-cell" [fxLayoutAlign]="'start center'" [fxFlex]="'35%'">
                  {{ 'DEVICE_DETAIL.TAB_SETTINGS.TEMPERATURE' | translate }}
                </td>
                <td class="mat-cell" [fxLayoutAlign]="'center center'" [fxFlex]="'65%'">
                  {{ currentDeviceConfiguration?.lastValues['TEMP']['value'] }}°C&nbsp;({{ currentDeviceConfiguration?.lastValues['TEMP']['timestamp'] | dateFormat }})
                </td>
              </tr>
              <tr class="table-row-content" *ngIf="currentDeviceConfiguration?.lastValues && currentDeviceConfiguration?.lastValues['SMS_DAY_COUNTER']">
                <td class="mat-cell" [fxLayoutAlign]="'start center'" [fxFlex]="'35%'">
                  {{ 'DEVICE_DETAIL.TAB_SETTINGS.SMS_DAY_COUNTER' | translate }}
                </td>
                <td class="mat-cell" [fxLayoutAlign]="'center center'" [fxFlex]="'65%'">
                  {{ currentDeviceConfiguration?.lastValues['SMS_DAY_COUNTER']['value'] }}&nbsp;({{ currentDeviceConfiguration?.lastValues['SMS_DAY_COUNTER']['timestamp'] | dateFormat }})
                </td>
              </tr>
              <tr class="table-row-content">
                <td class="mat-cell" [fxLayoutAlign]="'start center'" [fxFlex]="'35%'">
                  {{ 'DEVICE_DETAIL.TAB_SETTINGS.SMS_LIMITS' | translate }}
                </td>
                <td class="mat-cell" [fxLayoutAlign]="'center center'" [fxFlex]="'65%'">
                  {{ currentDeviceConfiguration?.configuration?.smsDailyLimit | number: '1.0-0' }}
                </td>
              </tr>
              <tr class="table-row-content">
                <td class="mat-cell" [fxLayoutAlign]="'start center'" [fxFlex]="'35%'">
                  {{ 'DEVICE_DETAIL.TAB_SETTINGS.CALL_SCHEDULING' | translate }}
                </td>
                <td class="mat-cell" [fxLayoutAlign]="'center center'" [fxFlex]="'65%'">
                  {{ currentDeviceConfiguration?.configuration?.callSchedule }}
                </td>
              </tr>
              <tr class="table-row-content">
                <td class="mat-cell" [fxLayoutAlign]="'start center'" [fxFlex]="'35%'">
                  {{ 'DEVICE_DETAIL.TAB_SETTINGS.GATEWAY_SHORT_NUMBER' | translate }}
                </td>
                <td class="mat-cell" [fxLayoutAlign]="'center center'" [fxFlex]="'65%'">
                  {{ currentDeviceConfiguration?.configuration?.SMSC }}
                </td>
              </tr>
              <tr class="table-row-content">
                <td class="mat-cell" [fxLayoutAlign]="'start center'" [fxFlex]="'35%'">
                  {{ 'DEVICE_DETAIL.TAB_SETTINGS.DEVICE_PHONE' | translate }}
                </td>
                <td class="mat-cell" [fxLayoutAlign]="'center center'" [fxFlex]="'65%'">
                  {{ currentDeviceConfiguration?.configuration?.phone }}
                </td>
              </tr>
              <tr class="table-row-content">
                <td class="mat-cell" [fxLayoutAlign]="'start center'" [fxFlex]="'35%'">
                  {{ 'DEVICE_DETAIL.TAB_SETTINGS.PHONE' | translate: { number: 1 } }}
                </td>
                <td class="mat-cell" [fxLayoutAlign]="'center center'" [fxFlex]="'65%'">
                  {{ currentDeviceConfiguration?.configuration?.phone1 }}
                </td>
              </tr>
              <tr class="table-row-content">
                <td class="mat-cell" [fxLayoutAlign]="'start center'" [fxFlex]="'35%'">
                  {{ 'DEVICE_DETAIL.TAB_SETTINGS.PHONE' | translate: { number: 2 } }}
                </td>
                <td class="mat-cell" [fxLayoutAlign]="'center center'" [fxFlex]="'65%'">
                  {{ currentDeviceConfiguration?.configuration?.phone2 }}
                </td>
              </tr>
              <tr class="table-row-content">
                <td class="mat-cell" [fxLayoutAlign]="'start center'" [fxFlex]="'35%'">
                  {{ 'DEVICE_DETAIL.TAB_SETTINGS.PHONE' | translate: { number: 3 } }}
                </td>
                <td class="mat-cell" [fxLayoutAlign]="'center center'" [fxFlex]="'65%'">
                  {{ currentDeviceConfiguration?.configuration?.phone3 }}
                </td>
              </tr>
              <tr class="table-row-content">
                <td class="mat-cell" [fxLayoutAlign]="'start center'" [fxFlex]="'35%'">
                  {{ 'DEVICE_DETAIL.TAB_SETTINGS.PHONE' | translate: { number: 4 } }}
                </td>
                <td class="mat-cell" [fxLayoutAlign]="'center center'" [fxFlex]="'65%'">
                  {{ currentDeviceConfiguration?.configuration?.phone4 }}
                </td>
              </tr>
              <tr class="table-row-content">
                <td class="mat-cell" [fxLayoutAlign]="'start center'" [fxFlex]="'35%'">
                  {{ 'DEVICE_DETAIL.TAB_SETTINGS.PHONE' | translate: { number: 5 } }}
                </td>
                <td class="mat-cell" [fxLayoutAlign]="'center center'" [fxFlex]="'65%'">
                  {{ currentDeviceConfiguration?.configuration?.phone5 }}
                </td>
              </tr>
              <tr class="table-row-content">
                <td class="mat-cell" [fxLayoutAlign]="'start center'" [fxFlex]="'35%'">
                  {{ 'DEVICE_DETAIL.TAB_SETTINGS.ALARM_RAW_THRESHOLD' | translate: { number: 1 } }}
                </td>
                <td class="mat-cell" [fxLayoutAlign]="'center center'" [fxFlex]="'65%'">
                  {{ currentDeviceConfiguration?.storages?.E1?.rawThreshold }}
                </td>
              </tr>
              <tr class="table-row-content">
                <td class="mat-cell" [fxLayoutAlign]="'start center'" [fxFlex]="'35%'">
                  {{ 'DEVICE_DETAIL.TAB_SETTINGS.ALARM_RAW_THRESHOLD' | translate: { number: 2 } }}
                </td>
                <td class="mat-cell" [fxLayoutAlign]="'center center'" [fxFlex]="'65%'">
                  {{ currentDeviceConfiguration?.storages?.E2?.rawThreshold }}
                </td>
              </tr>
              <tr class="table-row-content">
                <td class="mat-cell" [fxLayoutAlign]="'start center'" [fxFlex]="'35%'">
                  {{ 'DEVICE_DETAIL.TAB_SETTINGS.ALARM_RAW_THRESHOLD' | translate: { number: 3 } }}
                </td>
                <td class="mat-cell" [fxLayoutAlign]="'center center'" [fxFlex]="'65%'">
                  {{ currentDeviceConfiguration?.storages?.E3?.rawThreshold }}
                </td>
              </tr>
              <tr class="table-row-content">
                <td class="mat-cell" [fxLayoutAlign]="'start center'" [fxFlex]="'35%'">
                  {{ 'DEVICE_DETAIL.TAB_SETTINGS.ALARM_RAW_THRESHOLD' | translate: { number: 4 } }}
                </td>
                <td class="mat-cell" [fxLayoutAlign]="'center center'" [fxFlex]="'65%'">
                  {{ currentDeviceConfiguration?.storages?.E4?.rawThreshold }}
                </td>
              </tr>
              <tr class="table-row-content">
                <td class="mat-cell" [fxLayoutAlign]="'start center'" [fxFlex]="'35%'">
                  {{ 'DEVICE_DETAIL.TAB_SETTINGS.TEMP_RAW_THRESHOLD' | translate }}
                </td>
                <td class="mat-cell" [fxLayoutAlign]="'center center'" [fxFlex]="'65%'">
                  {{ currentDeviceConfiguration?.storages?.TEMP?.rawThreshold }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </mat-tab>

    <!-- Messages -->
    <mat-tab label="{{ 'DEVICE_DETAIL.TAB_INBOX_OUTBOX.TITLE' | translate }}">
      <div class="table-messages-container">
        <table mat-table [dataSource]="messagesDataSource" class="table-messages">

          <!-- Timestamp Column -->
          <ng-container matColumnDef="timestamp">
            <th mat-header-cell *matHeaderCellDef class="table-messages-timestamp-cell">{{
              'DEVICE_DETAIL.TAB_INBOX_OUTBOX.DATE' | translate }}</th>
            <td mat-cell *matCellDef="let element" class="table-messages-timestamp-cell">
              <div>{{ element.timestamp | dateFormat }}</div>
            </td>
          </ng-container>

          <!-- Origin Column -->
          <ng-container matColumnDef="origin">
            <th mat-header-cell *matHeaderCellDef class="table-messages-origin-cell">{{
              'DEVICE_DETAIL.TAB_INBOX_OUTBOX.ORIGIN' | translate }}</th>
            <td mat-cell *matCellDef="let element" class="table-messages-origin-cell">
              <div *ngIf="element.origin === 0"
                [matTooltip]="'DEVICE_DETAIL.TAB_INBOX_OUTBOX.ORIGIN_FROM_DEVICE' | translate"
                matTooltipPosition="above" matTooltipClass="regular-tooltip">
                <span class="material-icons" style="color: green">logout</span>
              </div>
              <div *ngIf="element.origin === 1"
                [matTooltip]="'DEVICE_DETAIL.TAB_INBOX_OUTBOX.ORIGIN_TO_DEVICE' | translate" matTooltipPosition="above"
                matTooltipClass="regular-tooltip">
                <span class="material-icons" style="color: orangered">login</span>
              </div>
            </td>
          </ng-container>

          <!-- Status Column -->
          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef class="table-messages-status-cell">{{
              'DEVICE_DETAIL.TAB_INBOX_OUTBOX.STATUS.TITLE' | translate }}</th>
            <td mat-cell *matCellDef="let element" class="table-messages-status-cell">
              <div *ngIf="element.origin === 1" style="display: inline-flex; padding-top: 5px;">
                <div class="dot-message" [style.background-color]="element.sendingStatusColor"></div>
                <div style="padding-left: 5px">
                  <span *ngIf="element.status === 1" translate>DEVICE_DETAIL.TAB_INBOX_OUTBOX.STATUS.PENDING</span>
                  <span *ngIf="element.status === 2" translate>DEVICE_DETAIL.TAB_INBOX_OUTBOX.STATUS.SENT</span>
                  <span *ngIf="element.status === 3"
                    translate>DEVICE_DETAIL.TAB_INBOX_OUTBOX.STATUS.SENDING_FAILURE</span>
                  <span *ngIf="element.status === 4" translate>DEVICE_DETAIL.TAB_INBOX_OUTBOX.STATUS.DELIVERED</span>
                  <span *ngIf="element.status === 5"
                    translate>DEVICE_DETAIL.TAB_INBOX_OUTBOX.STATUS.COULD_NOT_DELIVER</span>
                  <span *ngIf="element.status === 6" translate>DEVICE_DETAIL.TAB_INBOX_OUTBOX.STATUS.ANSWERED</span>
                </div>
              </div>
            </td>
          </ng-container>

          <!-- Content Column -->
          <ng-container matColumnDef="content">
            <th mat-header-cell *matHeaderCellDef>{{ 'DEVICE_DETAIL.TAB_INBOX_OUTBOX.CONTENT' | translate }}</th>
            <td mat-cell *matCellDef="let element">
              <ng-container *ngIf="element.origin === 0">
                <mat-expansion-panel (opened)="element.openState = true" (closed)="element.openState = false">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      <p class="table-inbox-messages-title-cell" [hidden]="element.openState">{{element.title}}</p>
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <div class="table-inbox-messages-content-cell" [innerHTML]="element.content"></div>
                </mat-expansion-panel>
              </ng-container>
              <ng-container *ngIf="element.origin === 1">
                <p class="table-outbox-messages-content-cell">{{element.content}}</p>
              </ng-container>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="['timestamp','origin','status','content']; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: ['timestamp','origin','status','content'];"></tr>
        </table>
        <div *ngIf="messagesDataSource.data.length == 0">{{ 'DEVICE_DETAIL.TAB_INBOX_OUTBOX.NO_MESSAGES' | translate }}
        </div>
      </div>
      <div style="padding-right: 100px;">
        <mat-paginator [pageSizeOptions]="[5, 10, 25]" [disabled]="loading" showFirstLastButtons></mat-paginator>
        <a mat-button href="javascript:void(0)" (click)="loadMessages()" [disabled]="loading"
          style="position: absolute; right: 50px; bottom: 10px;" [matTooltip]="'REFRESH' | translate"
          matTooltipPosition="above">
          <span class="material-icons">refresh</span>
        </a>
        <a mat-button href="javascript:void(0)" (click)="openExportMessagesDialog()" [disabled]="loading"
          style="position: absolute; right: 0; bottom: 10px;" [matTooltip]="'EXPORT' | translate"
          matTooltipPosition="above">
          <span class="material-icons">download</span>
        </a>
      </div>

    </mat-tab>

    <!-- Audittrail -->
    <mat-tab label="{{ 'DEVICE_DETAIL.TAB_AUDITTRAIL.TITLE' | translate }}">
      <div class="table-messages-container">
        <table mat-table [dataSource]="auditTrailDataSource" class="table-messages">

          <!-- Timestamp Column -->
          <ng-container matColumnDef="timestamp">
            <th mat-header-cell *matHeaderCellDef class="table-audit-timestamp-cell">{{
              'DEVICE_DETAIL.TAB_AUDITTRAIL.DATE' | translate }}</th>
            <td mat-cell *matCellDef="let element" class="table-audit-timestamp-cell">
              <div>{{ element.timestamp | dateFormat }}</div>
            </td>
          </ng-container>

          <!-- Username Column -->
          <ng-container matColumnDef="userName">
            <th mat-header-cell *matHeaderCellDef class="table-audit-username-cell">{{
              'DEVICE_DETAIL.TAB_AUDITTRAIL.USERNAME' | translate }}</th>
            <td mat-cell *matCellDef="let element" class="table-audit-username-cell" [matTooltip]="element.userName"
              matTooltipPosition="above">
              <div>{{ element.userName }}</div>
            </td>
          </ng-container>

          <!-- Content Column -->
          <ng-container matColumnDef="content">
            <th mat-header-cell *matHeaderCellDef class="table-audit-content-cell">{{
              'DEVICE_DETAIL.TAB_AUDITTRAIL.CONTENT' | translate }}</th>
            <td mat-cell *matCellDef="let element" class="table-audit-content-cell">
              <div [innerHTML]="element.content"></div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="['timestamp','userName','content']; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: ['timestamp', 'userName','content'];"></tr>
        </table>
        <div *ngIf="auditTrailDataSource.data.length == 0">{{ 'DEVICE_DETAIL.TAB_AUDITTRAIL.NO_AUDIT' | translate }}
        </div>
      </div>
      <div style="padding-right: 100px;">
        <mat-paginator [pageSizeOptions]="[5, 10, 25]" [disabled]="loading" showFirstLastButtons></mat-paginator>
        <a mat-button href="javascript:void(0)" (click)="loadAudit()" [disabled]="loading"
          style="position: absolute; right: 50px; bottom: 10px;" [matTooltip]="'REFRESH' | translate"
          matTooltipPosition="above">
          <span class="material-icons">refresh</span>
        </a>
        <a mat-button href="javascript:void(0)" (click)="openExportAuditDialog()" [disabled]="loading"
          style="position: absolute; right: 0; bottom: 10px;" [matTooltip]="'EXPORT' | translate"
          matTooltipPosition="above">
          <span class="material-icons">download</span>
        </a>
      </div>

    </mat-tab>

  </mat-tab-group>
  <mat-card-actions class="dialog-card-actions" fxLayoutAlign="end center">
    <!-- Storage level alarm threashold update -->
    <button *ngIf="selectedTabIndex == 0" class="pull-right" mat-button (click)="onClickUpdateDeviceConfiguration()"
      [disabled]="!storageForm.dirty || (!storageForm.valid && selectedStorageConfiguration.active) || updating || (!authService.isAdminUser && !authService.isSuperAdminUser)">
      <span *ngIf="!updating" translate>UPDATE</span>
      <mat-progress-spinner *ngIf="updating" mode="indeterminate" [diameter]="25" color="accent"></mat-progress-spinner>
    </button>
    <!-- Cyclical form update -->
    <button *ngIf="selectedTabIndex == 1" class="pull-right" mat-button (click)="onClickUpdateSchedulingCommand()"
      [disabled]="!cyclicalCallForm.dirty || !cyclicalCallForm.valid || updating || (!authService.isAdminUser && !authService.isSuperAdminUser)">
      <span *ngIf="!updating" translate>CONFIRM</span>
      <mat-progress-spinner *ngIf="updating" mode="indeterminate" [diameter]="25" color="accent"></mat-progress-spinner>
    </button>
    <!-- Manual SMS sending -->
    <button *ngIf="selectedTabIndex == 2" class="pull-right" mat-button (click)="onClickSendCommand()"
      [disabled]="!manualCommandForm.dirty || !manualCommandForm.valid || sending || (!authService.isAdminUser && !authService.isSuperAdminUser)">
      <span *ngIf="!sending" translate>SEND</span>
      <mat-progress-spinner *ngIf="sending" mode="indeterminate" [diameter]="25" color="accent">
      </mat-progress-spinner>
    </button>

    <!-- Dialog closing -->
    <button mat-button (click)="close()">
      <span translate>CLOSE</span>
    </button>
  </mat-card-actions>
</mat-card-content>